import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const path = this.element.getAttribute("data-image-upload-path");
    var myDropzone = new Dropzone("div#car-images", { 
      url: path,
      acceptedFiles: "image/png,image/gif,image/jpg,image/jpeg,image/pjpeg,image/tiff,image/bmp,image/vnd.adobe.photoshop,image/vnd.microsoft.icon,image/webp",
      headers: { "Accept": "text/html" },
      success: function(file, response) {
        document.getElementById('car-show-images').innerHTML =response;
        //$('#product-images').html(response);
      }
    });

    document.getElementsByClassName('c-image-position').forEach((item)=>{
      item.addEventListener('focusout', function(){
        console.log(item.value);
        let url = item.getAttribute('data-url');
        window.Rails.ajax({
          url: url,
          type: "patch",
          data: `position=${item.value}`,
          success: function(data) {
            console.log('saved');
          },
          error: function(data) {

          }
        })
      });
    });

    let price = parseInt(document.getElementById('car_price').getAttribute("data-value"));
    let discount1 = parseInt(document.getElementById('car_discount1').getAttribute("data-value"));
    let discount2 = parseInt(document.getElementById('car_discount2').getAttribute("data-value"));
    let discount3 =parseInt(document.getElementById('car_discount3').getAttribute("data-value"));
    let dealerDiscount = document.getElementById('car_dealer_discount');
    // 1.27 for CV cars (shown net), 1 otherwise — rendered from Car#vat_divisor
    // so this stays in step with Car#net_price.
    let vatDivisor = parseFloat(document.getElementById('calculated-price').getAttribute("data-vat-divisor")) || 1;
    dealerDiscount.addEventListener('change', (event) => {
      let dealerDiscountValue = dealerDiscount.value;
      let sum = Math.round((price - discount1 - discount2 - discount3 - dealerDiscountValue) / vatDivisor);
      document.getElementById("calculated-price").innerText = sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " Ft"
    });
  }
}
